<template>
  <div
    class="bg-gray-100 md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-no-wrap md:overflow-hidden border-r border-solid border-gray-200 bg-white flex-wrap items-center justify-between relative md:w-72 z-10 py-4 px-6"
  >
    <div class="mt-20">
      <h2 class="text-base mb-2 font-bold uppercase">Design Settings</h2>

      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase pr-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(1)"
            v-bind:class="{
              'text-gray-600 hover:text-gray-500 cursor-pointer': openTab !== 1,
              'text-gray-600 hover:text-gray-500 border-b-2 border-gray-500 cursor-pointer ':
                openTab === 1,
            }"
          >
            Themes
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase pr-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(2)"
            v-bind:class="{
              'text-gray-600 hover:text-gray-500 cursor-pointer': openTab !== 2,
              'text-gray-600 hover:text-gray-500 border-b-2 border-gray-500 cursor-pointer ':
                openTab === 2,
            }"
          >
            Page Design
          </a>
        </li>

        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a
            class="text-xs font-bold uppercase px-1 py-3 block leading-normal hover:no-underline"
            v-on:click="toggleTabs(3)"
            v-bind:class="{
              'text-gray-600 hover:text-gray-500 cursor-pointer': openTab !== 3,
              'text-gray-600 hover:text-gray-500 border-b-2 border-gray-500 cursor-pointer':
                openTab === 3,
            }"
          >
            Buttons
          </a>
        </li>
      </ul>

      <div v-if="openTab == 1">
        <div class="">
          <div
            v-for="(scheme, index) in schemes"
            :key="index"
            @click="applyTemplate(scheme)"
            class="py-2 text-center cursor-pointer mb-5 w-3/4 rounded shadow"
            :style="{ 'background-color': scheme.bgColor }"
          >
            <p
              class=""
              :style="{ color: scheme.fontColor, 'font-family': 'Roboto' }"
            >
              {{ scheme.name }}
            </p>
            <div class="flex flex-row justify-center">
              <div
                class="h-6 w-6 mr-1"
                :style="{
                  'background-color': scheme.accentColor,
                  border: '1px solid',
                  'border-color': scheme.accentColor,
                }"
              ></div>
              <div
                class="h-6 w-6"
                :style="{
                  'background-color': scheme.button_bgColor,
                  border: '1px solid',
                  'border-color': scheme.button_border,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="openTab == 2">
        <div class="text-sm font-semibold flex justify-between py-2">
          Font

          <div class="pt-0">
            <select
              type="text"
              v-model="font"
              placeholder="Placeholder"
              class="px-2 py-1 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
            >
              <option value="lato" style="font-family: 'Lato', san-serif"
                >Lato</option
              >
              <option value="lora" style="font-family: 'Lora', serif"
                >Lora</option
              >
              <option
                value="merriweather"
                style="font-family: 'Merriweather', serif"
                >Merriweather</option
              >
              <option
                value="montserrat"
                style="font-family: 'Montserrat', san-serif"
                >Montserrat</option
              >
              <option
                value="noto_sans"
                style="font-family: 'Noto Sans', san-serif"
                >Noto Sans</option
              >
              <option value="noto_jp" style="font-family: 'Noto JP', san-serif"
                >Noto JP</option
              >
              <option
                value="open_sans"
                style="font-family: 'Open Sans', san-serif"
                >Open Sans</option
              >
              <option value="oswald" style="font-family: 'Oswald', san-serif"
                >Oswald</option
              >
              <option value="poppins" style="font-family: 'Poppins', san-serif"
                >Poppins</option
              >
              <option value="raleway" style="font-family: 'Raleway', san-serif"
                >Raleway</option
              >
              <option value="roboto" style="font-family: 'Roboto', san-serif"
                >Roboto</option
              >
              <option
                value="source_sans"
                style="font-family: 'Source Sans Pro', san-serif"
                >Source Sans Pro</option
              >
            </select>
          </div>
        </div>

        <hr />

        <div class="text-sm font-semibold flex justify-between pt-2 pb-1">
          Font Color

          <v-swatches
            v-model="fontColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Background Color

          <v-swatches
            v-model="bgColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Panel Font Color

          <v-swatches
            v-model="fontColor2"
            :show-fallback="true"
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>

        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-3">
          Panel Size
          <input type="range" min="1" max="3" v-model="panelSize" />
        </div>

        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Image Accent Color

          <v-swatches
            v-model="accentColor"
            show-fallback
            :swatches="swatchColors"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
      </div>

      <div v-if="openTab == 3">
        <hr />
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Color

          <v-swatches
            v-model="buttonBgColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Font Color

          <v-swatches
            v-model="buttonFontColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />

        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Button Border Color

          <v-swatches
            v-model="buttonBorderColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />
         <hr />

        <div class="text-sm font-semibold mt-2 pt-2 pb-1">
          Skip Button Text (default button)
        </div>
        <input v-model="skip_button_text" class="px-2 text-gray-500 rounded border border-solid border-gray-300" />
        <hr class="mt-2" />
        <div class="text-sm font-semibold mt-2 mb-2 pt-2 ">
          Welcome Button Text
        </div>
        <input
          v-model="welcome_button_text" 
          class="px-2 text-gray-500 rounded border border-solid border-gray-300"
        />
        <hr class="mt-2" />
        <div class="text-sm font-semibold mt-2 pt-2 pb-1">
          Next Button Text
        </div>
        <input v-model="next_button_text" class="px-2 text-gray-500 rounded border border-solid border-gray-300" />

        <hr class="mt-2" />
        <div class="text-sm font-semibold mt-2 pt-2 pb-1">
          Close Button Text
        </div>
        <input v-model="close_button_text" class="px-2 text-gray-500 rounded border border-solid border-gray-300" />

        <hr class="mt-2" />
        <!--
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Panel Background Color

          <v-swatches
            v-model="panelColor"
            swatches="text-advanced"
            show-fallback
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>

        <hr />
        <div class="text-sm font-semibold mt-3 flex justify-between pt-2 pb-1">
          Panel Border Color

          <v-swatches
            v-model="borderColor"
            show-fallback
            swatches="text-advanced"
            fallback-input-type="color"
            popover-x="left"
            :trigger-style="{
              width: '22px',
              height: '22px',
              'border-radius': '0px',
              border: '1px solid black',
            }"
          ></v-swatches>
        </div>
        <hr />
-->
      </div>
    </div>
  </div>
</template>

<script>
//Vue Swatches: https://saintplay.github.io/vue-swatches/
import VSwatches from "vue-swatches";
// Import the styles too, typically in App.vue or main.js
import "vue-swatches/dist/vue-swatches.css";

import Survey from "@/models/Survey";
import Button from "@/models/Button";
import Step from "@/models/Step";
import { Templates } from "@/mixins/Templates.js";

export default {
  mixins: [Templates],
  components: { VSwatches },
  data() {
    return {
      openTab: 1,
    };
  },
  props: ["survey", "step"],
  computed: {
    disabled() {
      //disable option panel on welcome page and thank you page
      return this.step.type == "welcome" || this.step.type == "end";
    },
    swatchColors() {
      return [
        "#FFFFFF",
        "#FFDFBC",
        "#FF6A88 ",
        "#D496FB",
        "#eee666",
        "#6E8BFF",
        "#888888",
        "#000000",
      ];
    },
    font: {
      get() {
        return this.survey.font;
      },
      set(value) {
        if (value !== this.survey.font) {
          Survey.update({ where: this.survey.id, data: { font: value } });
        }
      },
    },
    fontColor: {
      get() {
        return this.survey.fontColor;
      },
      set(value) {
        if (value !== this.survey.fontColor) {
          Survey.update({ where: this.survey.id, data: { fontColor: value } });
        }
      },
    },
    bgColor: {
      get() {
        return this.survey.bgColor;
      },
      set(value) {
        if (value !== this.survey.bgColor) {
          Survey.update({ where: this.survey.id, data: { bgColor: value } });
        }
      },
    },
    button() {
      return this.survey.buttons[0];
    },
    buttonFontColor: {
      get() {
        return this.button.fontColor;
      },
      set(value) {
        if (value !== this.button.fontColor) {
          Button.update({
            where: this.button.id,
            data: { fontColor: value },
          });
        }
      },
    },
    buttonBgColor: {
      get() {
        return this.button.bgColor;
      },
      set(value) {
        if (value !== this.button.bgColor) {
          Button.update({
            where: this.button.id,
            data: { bgColor: value },
          });
        }
      },
    },
    buttonBorderColor: {
      get() {
        return this.button.borderColor;
      },
      set(value) {
        if (value !== this.button.borderColor) {
          Button.update({
            where: this.button.id,
            data: { borderColor: value },
          });
        }
      },
    },
    welcome_button_text: {
      get() {
        return this.button.welcome_text;
      },
      set(value) {
        if (value !== this.button.welcome_text) {
          Button.update({
            where: this.button.id,
            data: { welcome_text: value },
          });
        }
      },
    },
    skip_button_text: {
      get() {
        return this.button.skip_text;
      },
      set(value) {
        if (value !== this.button.skip_text) {
          Button.update({
            where: this.button.id,
            data: { skip_text: value },
          });
        }
      },
    },
    next_button_text: {
      get() {
        return this.button.next_text;
      },
      set(value) {
        if (value !== this.button.next_text) {
          Button.update({
            where: this.button.id,
            data: { next_text: value },
          });
        }
      },
    },
    close_button_text: {
      get() {
        return this.button.close_text;
      },
      set(value) {
        if (value !== this.button.close_text) {
          Button.update({
            where: this.button.id,
            data: { close_text: value },
          });
        }
      },
    },
    panelSize: {
      get() {
        if (this.step.size == "sm") return 1;
        if (this.step.size == "md") return 2;
        if (this.step.size == "lg") return 3;
        else return 0;
      },
      set(value) {
        if (value == 1)
          Step.update({ where: this.step.id, data: { size: "sm" } });
        else if (value == 2)
          Step.update({ where: this.step.id, data: { size: "md" } });
        else if (value == 3)
          Step.update({ where: this.step.id, data: { size: "lg" } });
      },
    },
    fontColor2: {
      get() {
        return this.survey.fontColor2;
      },
      set(value) {
        if (value !== this.survey.fontColor2) {
          Survey.update({ where: this.survey.id, data: { fontColor2: value } });
        }
      },
    },
    accentColor: {
      get() {
        return this.survey.accentColor;
      },
      set(value) {
        if (value !== this.survey.accentColor) {
          Survey.update({
            where: this.survey.id,
            data: { accentColor: value },
          });
        }
      },
    },
    panelColor: {
      get() {
        return this.survey.panelColor;
      },
      set(value) {
        if (value !== this.survey.panelColor) {
          Survey.update({ where: this.survey.id, data: { panelColor: value } });
        }
      },
    },
    borderColor: {
      get() {
        return this.survey.borderColor;
      },
      set(value) {
        if (value !== this.survey.borderColor) {
          Survey.update({
            where: this.survey.id,
            data: { borderColor: value },
          });
        }
      },
    },
  },
  methods: {
    toggleTabs: function(tabNumber) {
      this.openTab = tabNumber;
    },
    //applyTemplate(){} => moved to Template mixin
  },
};
</script>

<style>
.vue-swatches__fallback__input {
  padding-top: 0px;
  padding-bottom: 0px;
  cursor: pointer;
}
.vue-swatches__swatch {
  box-shadow: inset 0 0 2px rgb(0 0 0 / 75%);
}
</style>
